<template>
  <div class="layout-inner explore_entity_result job_board">
    <navbar></navbar>
    <div class="layout-container">
      <div class="layout-content">
        <template v-if="!isFilterPanelOpen && !isSortPanelOpen">
          <div class="sub_hd_bar">
            <div class="sub_hd_ic">
              <span @click="openFilterPanel" class="filter">
                <span class="ic ic-filter" :class="selectedFilterCount() > 0 ? 'active' : ''"></span>
                <span class="count" v-if="selectedFilterCount() > 0">
                  <span>{{ selectedFilterCount() }}</span>
                </span>
              </span>
            </div>
            <div class="srh_bx">
              <input type="text" class="search-input" :placeholder="$t('typeToNarrowResults')" v-on:keyup.enter="searchButtonClicked" v-model.trim="searchTerms"/>
              <span @click="searchButtonClicked" class="search-icon">
                <i class="fa fa-search" aria-hidden="true"></i>
              </span>
            </div>
            <div class="sort_by" @click="openSortPanel">
              <span class="sort_by_link">{{ $t('sort') }}</span>
            </div>
            <div class="list_info">
              {{ $t('exploringJobs', { total: total }) }}
            </div>
          </div>
        </template>

        <div class="container-fluid flex-grow-1 pg_content_container" style="padding-top: 0px;">
          <template v-if="isFilterPanelOpen">
            <div class="container filter_selection_flds_container">
              <template v-if="activeFilter === 'employer'">
                <div class="filter_fld_head">
                  <div class="hd_txt">{{ $t('selectEmployer') }}</div>
                </div>
                <div class="filter_fld_container">
                  <input type="text" class="search-input mb-2" :placeholder="$t('typeToFilterEmployer')" v-model.trim="employerSearch">
                  <label v-for="emp in filteredEmployers" :key="'employer-' + emp.value">
                    <input type="checkbox" :value="emp.value" v-model="employerSelected">
                    <span class="input_txt">{{ emp.text }}</span>
                  </label>
                </div>
                <div class="btn_container">
                  <b-btn @click="closeActiveFilter">{{ $t('ok') }}</b-btn>
                </div>
              </template>

              <template v-else-if="activeFilter === 'jobType'">
                <div class="filter_fld_head">
                  <div class="hd_txt">{{ $t('selectJobType') }}</div>
                </div>
                <div class="filter_fld_container">
                  <label v-for="type in jobType" :key="'jobType-' + type.value">
                    <input type="checkbox" :value="type.value" v-model="jobTypeSelected">
                    <span class="input_txt">{{ type.text }}</span>
                  </label>
                </div>
                <div class="btn_container">
                  <b-btn @click="closeActiveFilter">{{ $t('ok') }}</b-btn>
                </div>
              </template>

              <template v-else-if="activeFilter === 'salary'">
                <div class="filter_fld_head">
                  <div class="hd_txt">{{ $t('selectSalary') }}</div>
                </div>
                <div class="filter_fld_container">
                  <label v-for="range in salaryRangeGroups" :key="'salary-' + range.label">
                    <input type="checkbox" :value="range.label" v-model="salaryRangeSelected">
                    <span class="input_txt">{{ range.label }}</span>
                  </label>
                </div>
                <div class="btn_container">
                  <b-btn @click="closeActiveFilter">{{ $t('ok') }}</b-btn>
                </div>
              </template>

              <template v-else-if="activeFilter === 'distance'">
                <div class="filter_fld_head">
                  <div class="hd_txt">{{ $t('selectDistance') }}</div>
                </div>
                <div class="filter_fld_container">
                  <div class="distance-location-row">
                    <label for="distanceCity">{{ $t('city') }}</label>
                    <input id="distanceCity" type="text" class="search-input mb-2" v-model.trim="distanceCity" :placeholder="$t('city')">
                    <label for="distanceState">{{ $t('state') }}</label>
                    <v-select
                      id="distanceState"
                      class="distance-state-select mb-2"
                      v-model="distanceState"
                      :options="usStates"
                      :placeholder="$t('selectState')"
                      :clearable="true">
                    </v-select>
                  </div>
                  <label v-for="range in distanceOptions" :key="'distance-' + range.value">
                    <input type="radio" :value="range.value" v-model="distanceSelected">
                    <span class="input_txt">{{ range.label }}</span>
                  </label>
                </div>
                <div class="btn_container">
                  <b-btn @click="applyDistanceFilter">{{ $t('ok') }}</b-btn>
                </div>
              </template>

              <template v-else>
                <div class="filter_fld_head">
                  <div class="hd_txt">{{ $t('selectFilters') }}</div>
                </div>
                <div class="filter_options_container">
                  <div class="filter_option" @click.stop="activeFilter = 'employer'">
                    <label>{{ $t('employerFilter') }}</label>
                  </div>
                  <div class="filter_option" @click.stop="activeFilter = 'jobType'">
                    <label>{{ $t('type') }}</label>
                  </div>
                  <div class="filter_option" v-if="hasRecommendedJobs" @click.stop="toggleRecommendedFilter">
                    <label :class="{ 'is-active': showRecommendedOnly }">{{ $t('recommended') }}</label>
                  </div>
                  <div class="filter_option" @click.stop="activeFilter = 'salary'">
                    <label>{{ $t('salary') }}</label>
                  </div>
                  <div class="filter_option" @click.stop="openDistanceFilter">
                    <label>{{ $t('distance') }}</label>
                  </div>
                </div>
                <div class="selected_filters_container">
                  <div class="job-filter-chips">
                    <div class="job-filter-chip" v-for="(idxSelected, index) in jobTypeSelected" :key="'jobType-' + index">
                      <span class="job-filter-chip-label job-type-tag">{{ idxSelected }}</span>
                      <button type="button" class="job-filter-chip-remove" aria-label="delete" @click.stop="removeSelectedFacet('jobTypeSelected', index)">
                        <span class="ic_bin"></span>
                      </button>
                    </div>
                    <div class="job-filter-chip" v-for="(idxSelected, index) in employerSelected" :key="'employer-' + index">
                      <span class="job-filter-chip-label employer-tag">{{ idxSelected }}</span>
                      <button type="button" class="job-filter-chip-remove" aria-label="delete" @click.stop="removeSelectedFacet('employerSelected', index)">
                        <span class="ic_bin"></span>
                      </button>
                    </div>
                    <div class="job-filter-chip" v-for="(idxSelected, index) in salaryRangeSelected" :key="'salary-' + index">
                      <span class="job-filter-chip-label salary-tag">{{ idxSelected }}</span>
                      <button type="button" class="job-filter-chip-remove" aria-label="delete" @click.stop="removeSelectedFacet('salaryRangeSelected', index)">
                        <span class="ic_bin"></span>
                      </button>
                    </div>
                    <div class="job-filter-chip" v-if="distanceSelected" :key="'distance'">
                      <span class="job-filter-chip-label distance-tag">{{ distanceFilterLabel }}</span>
                      <button type="button" class="job-filter-chip-remove" aria-label="delete" @click.stop="removeSelectedFacet('distanceSelected')">
                        <span class="ic_bin"></span>
                      </button>
                    </div>
                    <div class="job-filter-chip" v-for="(idxSelected, index) in tagSelected" :key="'job-tag-' + index">
                      <span class="job-filter-chip-label job-applied-tag">{{ idxSelected.name || idxSelected }}</span>
                      <button type="button" class="job-filter-chip-remove" aria-label="delete" @click.stop="removeSelectedFacet('tagSelected', index)">
                        <span class="ic_bin"></span>
                      </button>
                    </div>
                    <div class="job-filter-chip" v-if="showRecommendedOnly && hasRecommendedJobs" :key="'recommended'">
                      <span class="job-filter-chip-label recommended-tag">{{ $t('recommended') }}</span>
                      <button type="button" class="job-filter-chip-remove" aria-label="delete" @click.stop="removeSelectedFacet('recommendedSelected')">
                        <span class="ic_bin"></span>
                      </button>
                    </div>
                  </div>
                  <div v-if="selectedFilterCount() === 0" class="no_result">{{ $t('noFilterSelected') }}</div>
                </div>
                <div class="btn_container">
                  <b-btn @click="closeFilterPanel">{{ $t('ok') }}</b-btn>
                </div>
              </template>
            </div>
          </template>

          <template v-else-if="isSortPanelOpen">
            <div class="container filter_selection_flds_container">
              <div class="filter_fld_head">
                <div class="hd_txt">{{ $t('sortBy') }}</div>
              </div>
              <div class="mt-2 ml-4">
                <div class="field-row mb-3" v-for="sort in sorts" :key="sort.name">
                  <div class="form-check">
                    <input type="radio" class="form-check-input" :id="'job-sort-' + sort.name" v-model="selectedSortName" :value="sort.name">
                    <label class="form-check-label" :for="'job-sort-' + sort.name">{{ sort.labelKey ? $t(sort.labelKey) : sort.name }}</label>
                  </div>
                </div>
                <div class="btn_container">
                  <b-btn @click="sortOkClicked">{{ $t('ok') }}</b-btn>
                </div>
              </div>
            </div>
          </template>

          <template v-else>
            <template v-if="isResultsLoaded">
              <template v-if="results && results.length > 0">
                <div class="job-result-row" v-for="(result, index) in results" :key="result.uuid" @click="goToJobDetail(result)">
                  <div class="job-result-main">
                    <div class="job-title-row">
                      <span class="job-title">{{ result.title }}</span>
                      <span class="recommendation-star" v-if="isRecommendedJob(result)" :title="$t('recommended')">
                        <span class="ic icon-star-full" aria-hidden="true"></span>
                      </span>
                      <span
                        class="ic_bm_container ace_sec_txt"
                        :class="{ bookmarked: isJobBookmark(result) }"
                        v-if="isBookmarkEnabled"
                        @click.stop="toggleJobBookmark(result)">
                        <span class="ic ic8-bookmark3"></span>
                      </span>
                    </div>
                    <div class="job-employer">
                      <div
                        class="employer-avatar"
                        :class="{ 'has-logo': employerLogo(result) }"
                        :style="employerLogo(result) ? null : { background: avatarColor(index) }">
                        <img v-if="employerLogo(result)" :src="employerLogo(result)" :alt="result.employer || ''">
                        <span v-else>{{ employerInitials(result.employer) }}</span>
                      </div>
                      <div class="employer-name">{{ result.employer }}</div>
                    </div>
                    <div class="job-meta-row">
                      <div class="job-meta-item job-salary-item">
                        <span class="ic_salary meta-icon" aria-hidden="true"></span>
                        <span class="salary-text" :title="result.salaryRange || $t('na')">{{ result.salaryRange || $t('na') }}</span>
                      </div>
                      <div class="job-meta-item job-type-item">
                        <span class="ic2_part-full-time-job meta-icon" aria-hidden="true"></span>
                        <span>{{ jobTypeLabel(result) }}</span>
                      </div>
                    </div>
                    <div class="job-meta-row">
                      <div class="job-meta-item">
                        <span class="ic2_applyBy meta-icon" aria-hidden="true"></span>
                        <span>{{ $t('applyBy') }} {{ applyByLabel(result.applyBy) }}</span>
                      </div>
                      <div class="job-meta-item">
                        <span class="icon-location meta-icon" aria-hidden="true"></span>
                        <span>{{ jobLocation(result) }}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="job-pagination">
                  <button type="button" class="btn" :disabled="pageNumber <= 1" @click="prevPage">{{ $t('previousPage') }}</button>
                  <span class="current-page">{{ pageNumber }}</span>
                  <button type="button" class="btn" :disabled="(from + size) >= total" @click="nextPage">{{ $t('nextPage') }}</button>
                </div>
              </template>
              <template v-else>
                <div class="row">
                  <div class="col-12 no_result mt-5">{{ $t('noResult') }}</div>
                </div>
              </template>
            </template>
            <template v-else>
              <div class="w-100 h-100 d-flex justify-content-center align-items-center">
                <spinner size="large"></spinner>
              </div>
            </template>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { DateTime } from 'luxon'
import { PACKAGE } from '../../../package_constants'
import Navbar from '../../misc/components/./Navbar'
import { getSimpleLibraryFilter } from '../../search/searchUtils'

const US_STATES = ['Alabama', 'Alaska', 'Arizona', 'Arkansas', 'California', 'Colorado', 'Connecticut', 'Delaware', 'Florida', 'Georgia', 'Hawaii', 'Idaho', 'Illinois', 'Indiana', 'Iowa', 'Kansas', 'Kentucky', 'Louisiana', 'Maine', 'Maryland', 'Massachusetts', 'Michigan', 'Minnesota', 'Mississippi', 'Missouri', 'Montana', 'Nebraska', 'Nevada', 'New Hampshire', 'New Jersey', 'New Mexico', 'New York', 'North Carolina', 'North Dakota', 'Ohio', 'Oklahoma', 'Oregon', 'Pennsylvania', 'Rhode Island', 'South Carolina', 'South Dakota', 'Tennessee', 'Texas', 'Utah', 'Vermont', 'Virginia', 'Washington', 'West Virginia', 'Wisconsin', 'Wyoming']

export default {
  name: 'jobBoard',
  components: {
    Navbar
  },
  data () {
    return {
      isResultsLoaded: false,
      isFilterPanelOpen: false,
      isSortPanelOpen: false,
      activeFilter: '',
      folders: [],
      allFolders: [],
      foldersSelected: [],
      privateLibraryList: [],
      publicLibraryList: [],
      jobType: [],
      jobTypeSelected: [],
      employer: [],
      employerSelected: [],
      salaryRangeSelected: [],
      distanceSelected: '',
      distanceCity: '',
      distanceState: '',
      defaultDistanceCity: '',
      defaultDistanceState: '',
      userLat: null,
      userLon: null,
      usStates: US_STATES,
      distanceOptions: [
        { label: '10 miles', value: '10 miles' },
        { label: '25 miles', value: '25 miles' },
        { label: '50 miles', value: '50 miles' },
        { label: '100 miles', value: '100 miles' }
      ],
      tagSelected: [],
      recommendedJobIds: [],
      showRecommendedOnly: false,
      recommendedJobIdsLoaded: false,
      salaryRangeGroups: [
        { label: 'Below $25,000', minLt: 25000 },
        { label: '$25,000-$50,000', minGt: 25000, maxLt: 50000 },
        { label: '$50,000-$75,000', minGt: 50000, maxLt: 75000 },
        { label: '$75,000-$100,000', minGt: 75000, maxLt: 100000 },
        { label: '$100,000-$150,000', minGt: 100000, maxLt: 150000 },
        { label: 'Above $150,000', minGt: 150000 }
      ],
      ignoreJobWatch: false,
      ignoreEmployerWatch: false,
      ignoreSalaryWatch: false,
      ignoreDistanceWatch: false,
      ignoreTagWatch: false,
      sorts: [
        {name: 'Relevance', clause: [{_score: {order: 'desc'}}]},
        {name: 'Title', labelKey: 'title', clause: [{'title.raw': {order: 'asc'}}]},
        {name: 'Employer', labelKey: 'employerFilter', clause: [{'employer.keyword': {order: 'asc'}}]},
        {name: 'Posted On', labelKey: 'postedOn', clause: [{creationTime: {order: 'desc'}}]},
        {name: 'Apply By', labelKey: 'applyBy', clause: [{applyBy: {order: 'asc'}}]},
        {name: 'Salary', clause: [{minSalary: {order: 'asc'}}]},
        {name: 'Distance', labelKey: 'distance', clause: []}
      ],
      selectedSortName: 'Title',
      searchTerms: '',
      employerSearch: '',
      avatarColors: ['#e08a4a', '#3d5a99', '#9b8ac4', '#4a7c8c'],
      source: ['title', 'uuid', 'name', 'description', 'type', 'employer', 'employerUuid', 'salaryRange', 'minSalary', 'maxSalary', 'contactInfo', 'jobTypes', 'geoLocation', 'creationTime', 'postedDate', 'applyBy', 'viewCount', 'applicantCount', 'lastUpdatedTime', 'thumbnail', 'thumbnailURI', 'thumbnailURIList', 'uri', '_score', 'appliedTagMap', 'aggregatedAppliedTags', 'fileType', 'originUuid', 'master', 'careerCompetenciesMap', 'careerCompetenciesList', 'ownerId', 'ownerName']
    }
  },
  computed: {
    ...mapState({
      'results': state => state.job.results,
      'total': state => state.job.total,
      'from': state => state.job.from,
      'pageNumber': state => state.job.pageNumber,
      'size': state => state.job.size,
      'facetResults': state => state.job.aggregations,
      'libraryPositionMapping': state => state.job.libraryPositionMapping,
      'selectedFacets': state => state.job.selectedFacets,
      'enabledFeatures': state => state.dashboard.enabledFeatures,
      'bookmarks': state => state.explore.bookmarks,
      'institution': state => state.dashboard.institution,
      'userObj': state => state.login.userObj
    }),
    isBookmarkEnabled () {
      let bookmarkFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.BOOKMARK_FEATURE_ID]
      return !!(bookmarkFeature && bookmarkFeature.enabled)
    },
    hasRecommendedJobs () {
      return this.recommendedJobIds && this.recommendedJobIds.length > 0
    },
    selectedSort () {
      if (this.selectedSortName === 'Distance' && this.hasUserLocation) {
        return [this.geoDistanceSort()]
      }
      let selected = this.sorts.find((sort) => {
        return sort.name === this.selectedSortName
      })
      if (!selected || !selected.clause || selected.clause.length === 0) {
        selected = this.sorts[1]
      }
      return selected.clause.slice()
    },
    hasUserLocation () {
      return typeof this.userLat === 'number' && typeof this.userLon === 'number' &&
        !isNaN(this.userLat) && !isNaN(this.userLon)
    },
    distanceFilterLabel () {
      let found = this.distanceOptions.find((range) => {
        return range.value === this.distanceSelected
      })
      let rangeLabel = found ? found.label : this.distanceSelected
      let place = [this.distanceCity, this.distanceState].filter(Boolean).join(', ')
      if (place) {
        return rangeLabel + ' of ' + place
      }
      return rangeLabel
    },
    filteredEmployers () {
      let employers = this.employer
      if (employers && employers.length > 0) {
        return employers.filter(item => {
          let name = item.value || item.text || ''
          return name.toLowerCase().indexOf(this.employerSearch.toLowerCase()) > -1
        })
      }
      return employers
    }
  },
  watch: {
    '$route' (to, from) {
      let toEmployer = (to.query && to.query.employer) || ''
      let fromEmployer = (from && from.query && from.query.employer) || ''
      let toTag = (to.query && to.query.tag) || ''
      let fromTag = (from && from.query && from.query.tag) || ''
      if (toEmployer !== fromEmployer) {
        this.applyIncomingEmployerFilter()
        this.constructQuery()
      }
      if (toTag !== fromTag) {
        this.applyIncomingTagFilter()
        this.constructQuery()
      }
    },
    facetResults () {
      this.processFacetResult(this.facetResults.jobType, 'jobType')
      this.processFacetResult(this.facetResults.employer, 'employer')
    },
    jobTypeSelected () {
      if (this.ignoreJobWatch) {
        this.ignoreJobWatch = false
      } else {
        this.storeJobSelectedFacets({key: 'jobTypeSelected', value: this.jobTypeSelected})
        if (!this.isFilterPanelOpen) {
          this.updateFacet()
        }
      }
    },
    employerSelected () {
      if (this.ignoreEmployerWatch) {
        this.ignoreEmployerWatch = false
      } else {
        this.storeJobSelectedFacets({key: 'employerSelected', value: this.employerSelected})
        if (!this.isFilterPanelOpen) {
          this.updateFacet()
        }
      }
    },
    salaryRangeSelected () {
      if (this.ignoreSalaryWatch) {
        this.ignoreSalaryWatch = false
      } else {
        this.storeJobSelectedFacets({key: 'salaryRangeSelected', value: this.salaryRangeSelected})
        if (!this.isFilterPanelOpen) {
          this.updateFacet()
        }
      }
    },
    distanceSelected () {
      if (this.ignoreDistanceWatch) {
        this.ignoreDistanceWatch = false
      } else {
        this.storeJobSelectedFacets({key: 'distanceSelected', value: this.distanceSelected ? [this.distanceSelected] : []})
      }
    },
    tagSelected () {
      if (this.ignoreTagWatch) {
        this.ignoreTagWatch = false
      } else {
        this.updateFacet()
        this.storeJobSelectedFacets({key: 'tagSelected', value: this.tagSelected})
      }
    }
  },
  mounted () {
    this.updateJobPageNumber(1)
    this.updateJobFrom(0)
    this.populateUserLibrary()
  },
  methods: {
    ...mapActions([
      'loadUserObj',
      'loadInstitutionDetail',
      'loadInstitutionPackage',
      'loadAllLibraryForUser',
      'constructJobSearchQuery',
      'updateJobFrom',
      'updateJobPageNumber',
      'loadJobLibraryPositionMapping',
      'storeJobSelectedFacets',
      'loadCreateBookmarks',
      'loadDeleteBookmark',
      'loadAllBookmarks',
      'loadAllJobIdsWithRecommendation'
    ]),
    openFilterPanel () {
      this.isFilterPanelOpen = true
      this.activeFilter = ''
    },
    closeFilterPanel () {
      this.isFilterPanelOpen = false
      this.activeFilter = ''
      this.updateFacet()
    },
    closeActiveFilter () {
      this.activeFilter = ''
      this.updateFacet()
    },
    openSortPanel () {
      this.isSortPanelOpen = true
    },
    openDistanceFilter () {
      this.activeFilter = 'distance'
      this.ensureDefaultCityState()
    },
    selectedFilterCount () {
      let count = this.jobTypeSelected.length + this.employerSelected.length + this.salaryRangeSelected.length + this.tagSelected.length
      if (this.distanceSelected) {
        count += 1
      }
      if (this.showRecommendedOnly && this.hasRecommendedJobs) {
        count += 1
      }
      return count
    },
    async applyDistanceFilter () {
      this.activeFilter = ''
      if (this.distanceSelected) {
        let resolved = await this.resolveDistanceLocation()
        if (!resolved) {
          this.ignoreDistanceWatch = true
          this.distanceSelected = ''
          this.storeJobSelectedFacets({key: 'distanceSelected', value: []})
          return
        }
        this.storeJobSelectedFacets({key: 'distanceSelected', value: [this.distanceSelected]})
      } else {
        this.storeJobSelectedFacets({key: 'distanceSelected', value: []})
      }
      this.updateFacet()
    },
    async ensureDefaultCityState () {
      if (this.distanceCity || this.distanceState) {
        return
      }
      let located = await this.ensureUserLocation({ notify: false })
      if (!located) {
        return
      }
      await this.reverseGeocodeCurrentLocation()
    },
    async resolveDistanceLocation () {
      let city = (this.distanceCity || '').trim()
      let state = (this.distanceState || '').trim()
      let locationChanged = city !== this.defaultDistanceCity || state !== this.defaultDistanceState
      if (city || state) {
        if (locationChanged || !this.hasUserLocation) {
          return this.geocodeCityState(city, state)
        }
        return true
      }
      return this.ensureUserLocation()
    },
    geocodeCityState (city, state) {
      let query = [city, state, 'USA'].filter(Boolean).join(', ')
      let url = 'https://nominatim.openstreetmap.org/search?format=json&limit=1&addressdetails=1&q=' + encodeURIComponent(query)
      return fetch(url, { headers: { 'Accept': 'application/json' } }).then((res) => {
        if (!res.ok) {
          throw new Error('geocode failed')
        }
        return res.json()
      }).then((results) => {
        if (!results || !results.length || !results[0].lat || !results[0].lon) {
          this.notifyFailure(this.$t('unableToFindCityState'))
          return false
        }
        this.userLat = Number(results[0].lat)
        this.userLon = Number(results[0].lon)
        if (isNaN(this.userLat) || isNaN(this.userLon)) {
          this.notifyFailure(this.$t('unableToFindCityState'))
          return false
        }
        return true
      }).catch(() => {
        this.notifyFailure(this.$t('unableToFindCityState'))
        return false
      })
    },
    reverseGeocodeCurrentLocation () {
      if (!this.hasUserLocation) {
        return Promise.resolve()
      }
      let url = 'https://nominatim.openstreetmap.org/reverse?format=jsonv2&zoom=10&addressdetails=1&lat=' + this.userLat + '&lon=' + this.userLon
      return fetch(url, { headers: { 'Accept': 'application/json' } }).then((res) => {
        if (!res.ok) {
          return null
        }
        return res.json()
      }).then((result) => {
        if (!result || !result.address) {
          return
        }
        let parsed = this.parseNominatimAddress(result.address)
        this.distanceCity = parsed.city
        this.distanceState = parsed.state
        this.defaultDistanceCity = parsed.city
        this.defaultDistanceState = parsed.state
      }).catch(() => {})
    },
    parseNominatimAddress (address) {
      let city = address.city || address.town || address.village || address.hamlet || address.municipality || ''
      let state = address.state || ''
      if (state && this.usStates.indexOf(state) === -1) {
        let match = this.usStates.find((name) => {
          return name.toLowerCase() === state.toLowerCase()
        })
        if (match) {
          state = match
        }
      }
      return { city: city, state: state }
    },
    needsUserLocation () {
      return !!this.distanceSelected || this.selectedSortName === 'Distance'
    },
    geoDistancePoint () {
      return {
        lat: this.userLat,
        lon: this.userLon
      }
    },
    geoDistanceSort () {
      return {
        _geo_distance: {
          geoLocation: this.geoDistancePoint(),
          order: 'asc',
          unit: 'mi',
          ignore_unmapped: true
        }
      }
    },
    isSecureGeolocationContext () {
      if (typeof window === 'undefined') {
        return false
      }
      return !!window.isSecureContext
    },
    getBrowserPosition (options, waitMs) {
      return new Promise((resolve, reject) => {
        let settled = false
        let wait = waitMs || 25000
        let timer = setTimeout(() => {
          if (settled) {
            return
          }
          settled = true
          let timeoutError = new Error('Timeout')
          timeoutError.code = 3
          reject(timeoutError)
        }, wait)
        try {
          navigator.geolocation.getCurrentPosition(
            (position) => {
              if (settled) {
                return
              }
              settled = true
              clearTimeout(timer)
              resolve(position)
            },
            (error) => {
              if (settled) {
                return
              }
              settled = true
              clearTimeout(timer)
              reject(error)
            },
            options
          )
        } catch (error) {
          if (settled) {
            return
          }
          settled = true
          clearTimeout(timer)
          reject(error)
        }
      })
    },
    locationErrorMessage (error) {
      let code = error && error.code
      if (!this.isSecureGeolocationContext()) {
        return this.$t('locationRequiresHttps')
      }
      if (code === 1) {
        return this.$t('locationPermissionBlocked')
      }
      if (code === 3) {
        return this.$t('locationTimedOut')
      }
      return this.$t('unableToGetLocation')
    },
    applyBrowserPosition (position) {
      if (!position || !position.coords) {
        return false
      }
      let lat = Number(position.coords.latitude)
      let lon = Number(position.coords.longitude)
      if (isNaN(lat) || isNaN(lon)) {
        return false
      }
      this.userLat = lat
      this.userLon = lon
      return true
    },
    async ensureUserLocation (options) {
      let notify = !(options && options.notify === false)
      if (this.hasUserLocation) {
        return true
      }
      if (!navigator.geolocation) {
        if (notify) {
          this.notifyFailure(this.$t('locationNotAvailable'))
        }
        return false
      }
      if (!this.isSecureGeolocationContext()) {
        if (notify) {
          this.notifyFailure(this.locationErrorMessage({ code: 1 }))
        }
        return false
      }
      let attempts = [
        { enableHighAccuracy: false, maximumAge: 600000 },
        { enableHighAccuracy: false, maximumAge: 0 }
      ]
      let lastError = null
      for (let i = 0; i < attempts.length; i++) {
        try {
          let position = await this.getBrowserPosition(attempts[i], 25000)
          if (this.applyBrowserPosition(position)) {
            return true
          }
        } catch (error) {
          lastError = error
          if (error && error.code === 1) {
            break
          }
        }
      }
      if (notify) {
        this.notifyFailure(this.locationErrorMessage(lastError))
      }
      return false
    },
    async toggleRecommendedFilter () {
      if (!this.showRecommendedOnly) {
        await this.loadRecommendedJobIds()
      }
      this.showRecommendedOnly = !this.showRecommendedOnly
      this.storeJobSelectedFacets({key: 'recommendedSelected', value: this.showRecommendedOnly ? ['Recommended'] : []})
      this.updateFacet()
    },
    searchButtonClicked () {
      this.updateJobPageNumber(1)
      this.updateJobFrom(0)
      this.constructQuery()
    },
    async sortOkClicked () {
      this.isSortPanelOpen = false
      if (this.selectedSortName === 'Distance') {
        let resolved = await this.resolveDistanceLocation()
        if (!resolved) {
          this.selectedSortName = 'Title'
          return
        }
      }
      this.constructQuery()
    },
    millisToDate (millis) {
      if (millis === undefined || millis === null || millis === '') {
        return this.$t('na')
      }
      let value = millis
      if (typeof millis === 'object') {
        value = millis.epochMillis || millis.millis || millis.time || millis.epochSecond
      }
      if (typeof value === 'number' && value < 1e12) {
        value = value * 1000
      }
      let parsed = DateTime.fromMillis(Number(value))
      return parsed.isValid ? parsed.toFormat('MM/dd/yyyy') : this.$t('na')
    },
    applyByLabel (applyBy) {
      let value = applyBy
      if (value && typeof value === 'object') {
        value = value.epochMillis || value.millis || value.time || value.epochSecond
      }
      if (!value || Number(value) === 0) {
        return this.$t('untilFilled')
      }
      return this.millisToDate(value)
    },
    jobTypeLabel (result) {
      if (result && result.jobTypes && result.jobTypes.length > 0) {
        return result.jobTypes[0]
      }
      return this.$t('na')
    },
    jobLocation (result) {
      if (result && result.contactInfo && result.contactInfo.addresses && result.contactInfo.addresses.length > 0) {
        let address = result.contactInfo.addresses[0]
        let city = address.city || ''
        let state = address.state || ''
        if (city && state) {
          return city + ', ' + state
        }
        return city || state || this.$t('na')
      }
      return this.$t('na')
    },
    employerLogo (result) {
      if (!result) {
        return ''
      }
      return result.thumbnail || result.thumbnailURI || ''
    },
    employerInitials (title) {
      if (!title) {
        return ''
      }
      let first = title.trim().split(/\s+/)[0]
      if (first.length <= 4) {
        return first.toUpperCase()
      }
      return first.substring(0, 3).toUpperCase()
    },
    avatarColor (index) {
      return this.avatarColors[index % this.avatarColors.length]
    },
    populateUserLibrary () {
      this.isResultsLoaded = false
      this.setupUserLibraries()
    },
    sortLibrariesIntoStandardOrder (libraries) {
      var sortedLibraryList = []
      for (var attr in this.libraryPositionMapping) {
        var value = this.libraryPositionMapping[attr]
        for (var i = 0; i < libraries.length; i++) {
          var library = libraries[i]
          if (this.libraryMatches(library, value)) {
            sortedLibraryList.push(library)
          }
        }
      }
      return sortedLibraryList.length > 0 ? sortedLibraryList : libraries
    },
    libraryMatches (library, value) {
      if (!library || !library.category) {
        return false
      }
      if (library.category === 'LearningSpace') {
        if (library.title === 'Shared With Me') {
          return value === 'Shared'
        }
        return value === 'Global'
      }
      return library.category.indexOf(value) !== -1
    },
    async toggleJobBookmark (job) {
      if (this.isJobBookmark(job)) {
        await this.deleteJobBookmark(job)
      } else {
        await this.bookmarkJob(job)
      }
    },
    async bookmarkJob (job) {
      const bookmark = {
        'source': 'explore',
        'entityType': 'job',
        'entityTitle': job.title,
        'entityUuid': job.uuid,
        'institutionId': job.employerId || job.employerUuid,
        'userId': this.userObj.uuid
      }
      const response = await this.loadCreateBookmarks(bookmark)
      const message = (response ? this.$t('successfullyBookmarked') : this.$t('unableToBookmark')) + ' \'' + job.title + '\''
      if (response) {
        this.notifySuccess(message)
      } else {
        this.notifyFailure(message)
      }
      await this.loadAllBookmarks()
    },
    async deleteJobBookmark (job) {
      await this.loadDeleteBookmark(job.bookmark.uuid)
      this.notifySuccess(this.$t('successfullyDeletedBookmark') + ' \'' + job.title + '\'')
      await this.loadAllBookmarks()
    },
    isJobBookmark (job) {
      let bookmarks = this.bookmarks
      if (!bookmarks || !bookmarks.length) {
        return false
      }
      let target = false
      bookmarks.forEach(bookmark => {
        if (bookmark.entityUuid === job.uuid) {
          target = bookmark
          job.bookmark = bookmark
        }
      })
      return target
    },
    notifySuccess (text) {
      return this.$notify({
        group: 'notify',
        type: 'success',
        title: '',
        text: text
      })
    },
    notifyFailure (text) {
      return this.$notify({
        group: 'notify',
        type: 'error',
        title: '',
        text: text
      })
    },
    updateFacet () {
      this.isResultsLoaded = false
      this.updateJobPageNumber(1)
      this.updateJobFrom(0)
      this.constructQuery()
    },
    async setupUserLibraries () {
      await this.loadUserObj()
      await this.loadJobLibraryPositionMapping()
      let institution = await this.loadInstitutionDetail(this.userObj.institutionId)
      await this.loadInstitutionPackage({uuid: this.userObj.institutionId, isAggregated: false})
      await this.loadAllBookmarks()
      let res = this.userObj
      let userPreferences = res.userPreferences || {}
      let selectedLearningSpaces = userPreferences.learningSpaces || []
      let libraries = await this.loadAllLibraryForUser(this.userObj.uuid)
      this.folders = []
      this.allFolders = []
      this.foldersSelected = []
      this.publicLibraryList = []
      this.privateLibraryList = []
      let learningSpaces = this.sortLibrariesIntoStandardOrder(libraries || [])
      if (learningSpaces && learningSpaces.length > 0) {
        for (var i = 0; i < learningSpaces.length; i++) {
          let learningSpace = learningSpaces[i]
          const category = learningSpace.category
          if (category === 'LearningSpace' || category === 'Institute_Public' || category === 'User_Private') {
            this.folders.push({value: learningSpace.uuid, text: learningSpace.displayName + '[0]'})
            this.allFolders.push(learningSpace.uuid)
            if (selectedLearningSpaces.indexOf(learningSpace.uuid) !== -1) {
              this.foldersSelected.push(learningSpace.uuid)
            }
            if (category !== 'Institute' && category !== 'User_Private') {
              this.publicLibraryList.push(learningSpace.uuid)
            }
            if (category === 'User_Private') {
              this.privateLibraryList.push(learningSpace.uuid)
            }
          }
        }
      }
      let employerMappings = []
      if (institution && institution.institutionEmployerMapping) {
        employerMappings = institution.institutionEmployerMapping
      } else if (this.institution && this.institution.institutionEmployerMapping) {
        employerMappings = this.institution.institutionEmployerMapping
      }
      employerMappings.forEach((mapping) => {
        let status = mapping && mapping.status ? String(mapping.status) : ''
        if (status.toLowerCase() === 'approved' && mapping.employerLibraryId) {
          this.publicLibraryList.push(mapping.employerLibraryId)
          this.foldersSelected.push(mapping.employerLibraryId)
          if (this.allFolders.indexOf(mapping.employerLibraryId) === -1) {
            this.allFolders.push(mapping.employerLibraryId)
          }
        }
      })
      this.populateSelectedFacetsFromState()
      this.applyIncomingEmployerFilter()
      this.applyIncomingTagFilter()
      await this.loadRecommendedJobIds()
      if (!this.hasRecommendedJobs && this.showRecommendedOnly) {
        this.showRecommendedOnly = false
        this.storeJobSelectedFacets({key: 'recommendedSelected', value: []})
      }
      this.constructQuery()
    },
    goToJobDetail (result) {
      if (result && result.uuid) {
        this.$router.push({ name: 'jobHome', params: { uuid: result.uuid } })
      }
    },
    prevPage () {
      if (this.pageNumber >= 1 && (this.from - this.size) >= 0) {
        this.updateJobPageNumber(this.pageNumber - 1)
        this.updateJobFrom(this.from - this.size)
        this.constructQuery()
      }
    },
    nextPage () {
      if ((this.from + this.size) < this.total) {
        this.updateJobPageNumber(this.pageNumber + 1)
        this.updateJobFrom(this.from + this.size)
        this.constructQuery()
      }
    },
    buildFacet (field, size, order) {
      return {
        'aggs': {
          'termObj': {
            'terms': {
              'field': field,
              'size': size,
              'order': order
            }
          }
        },
        'filter': this.getFacetFilter()
      }
    },
    processFacetResult (facetResult, facetListName) {
      if (!facetResult) {
        return
      }
      this[facetListName] = []
      let terms = facetResult.termObj && facetResult.termObj.buckets ? facetResult.termObj.buckets : []
      for (var i = 0; i < terms.length; i++) {
        this[facetListName].push({
          'text': terms[i].key + '[' + terms[i].doc_count + ']',
          'value': terms[i].key
        })
      }
    },
    async constructQuery () {
      this.isResultsLoaded = false
      let libraryList = this.allFolders.length > 0 ? this.allFolders.join(',') : (this.publicLibraryList.concat(this.privateLibraryList).join(',') || ',')
      let facets = {
        'jobType': this.buildFacet('jobTypes.raw', 100, {'_key': 'asc'}),
        'employer': this.buildFacet('employer.keyword', 1000, {'_key': 'asc'})
      }
      if (this.needsUserLocation()) {
        let located = this.hasUserLocation
        if (!located) {
          located = await this.resolveDistanceLocation()
        }
        if (!located) {
          if (this.distanceSelected) {
            this.ignoreDistanceWatch = true
            this.distanceSelected = ''
            this.storeJobSelectedFacets({key: 'distanceSelected', value: []})
          }
          if (this.selectedSortName === 'Distance') {
            this.selectedSortName = 'Title'
          }
        }
      }
      let filter = this.generateFilter()
      await this.constructJobSearchQuery({
        terms: this.searchTerms,
        sort: this.selectedSort,
        preserveSort: true,
        source: this.source,
        from: this.from,
        size: this.size,
        indexList: 'job',
        libraryList: libraryList,
        privateLibraryList: this.privateLibraryList,
        publicLibraryList: this.publicLibraryList,
        userId: this.userObj.uuid,
        aggs: facets,
        filter: filter
      })
      this.isResultsLoaded = true
    },
    generateFilter () {
      var filterObj = {
        'bool': this.originUuidCheck()
      }
      let selectedLibraryIds = this.foldersSelected.slice()
      if (selectedLibraryIds.length === 0) {
        this.folders.forEach((folder) => {
          selectedLibraryIds.push(folder.value)
        })
      }
      if (selectedLibraryIds.length === 0) {
        selectedLibraryIds = this.publicLibraryList.concat(this.privateLibraryList)
      }
      if (selectedLibraryIds.length > 0) {
        filterObj.bool.must.push({
          'bool': {
            'should': [
              getSimpleLibraryFilter(selectedLibraryIds)
            ]
          }
        })
      }
      filterObj.bool.must.push({
        'terms': {
          '_type': ['Job']
        }
      })
      if (this.jobTypeSelected.length > 0) {
        filterObj.bool.must.push({
          'terms': {
            'jobTypes.raw': this.jobTypeSelected
          }
        })
      }
      if (this.employerSelected.length > 0) {
        filterObj.bool.must.push({
          'terms': {
            'employer.keyword': this.employerSelected
          }
        })
      }
      if (this.salaryRangeSelected.length > 0) {
        let salaryQueries = this.selectedSalaryRangeQueries()
        if (salaryQueries.length === 1) {
          filterObj.bool.must.push(salaryQueries[0])
        } else if (salaryQueries.length > 1) {
          filterObj.bool.must.push({
            'bool': {
              'should': salaryQueries,
              'minimum_should_match': 1
            }
          })
        }
      }
      if (this.tagSelected.length > 0) {
        filterObj.bool.must.push(this.buildTagFilter())
      }
      if (this.showRecommendedOnly) {
        if (this.recommendedJobIds.length > 0) {
          filterObj.bool.must.push({
            'terms': {
              'uuid': this.recommendedJobIds
            }
          })
        } else {
          filterObj.bool.must.push({
            'bool': {
              'must_not': {
                'match_all': {}
              }
            }
          })
        }
      }
      if (this.distanceSelected && this.hasUserLocation) {
        filterObj.bool.must.push({
          'geo_distance': {
            'distance': this.distanceSelected,
            'distance_type': 'arc',
            'geoLocation': {
              'lat': Number(this.userLat),
              'lon': Number(this.userLon)
            }
          }
        })
      }
      return filterObj
    },
    getFacetFilter () {
      return {
        'bool': this.originUuidCheck()
      }
    },
    originUuidCheck () {
      return {
        'must': [],
        'must_not': {
          'exists': {
            'field': 'originUuid'
          }
        }
      }
    },
    populateSelectedFacetsFromState () {
      this.ignoreJobWatch = true
      this.jobTypeSelected = this.selectedFacets.jobTypeSelected || []
      this.ignoreEmployerWatch = true
      if (this.$route.query.employer) {
        this.employerSelected = [this.$route.query.employer]
      } else {
        this.employerSelected = this.selectedFacets.employerSelected || []
      }
      this.ignoreSalaryWatch = true
      this.salaryRangeSelected = this.selectedFacets.salaryRangeSelected || []
      this.ignoreDistanceWatch = true
      this.distanceSelected = (this.selectedFacets.distanceSelected && this.selectedFacets.distanceSelected[0]) || ''
      this.ignoreTagWatch = true
      if (this.$route.query.tag) {
        this.tagSelected = [this.normalizeTagSelection(this.$route.query.tag)]
      } else {
        this.tagSelected = this.selectedFacets.tagSelected || []
      }
      this.showRecommendedOnly = !!(this.hasRecommendedJobs && this.selectedFacets.recommendedSelected && this.selectedFacets.recommendedSelected.length)
    },
    applyIncomingTagFilter () {
      let tagName = this.$route.query.tag
      if (!tagName) {
        return
      }
      this.ignoreTagWatch = true
      this.tagSelected = [this.normalizeTagSelection(tagName)]
      this.storeJobSelectedFacets({key: 'tagSelected', value: this.tagSelected})
    },
    normalizeTagSelection (tag) {
      if (!tag) {
        return { name: '', category: '' }
      }
      if (typeof tag === 'string') {
        return { name: tag, category: '' }
      }
      return {
        name: tag.name || '',
        category: tag.category || ''
      }
    },
    tagSelectionName (tag) {
      if (!tag) {
        return ''
      }
      return tag.name || tag
    },
    buildTagFilter () {
      let must = []
      this.tagSelected.forEach((tag) => {
        let selected = this.normalizeTagSelection(tag)
        if (!selected.name) {
          return
        }
        let should = []
        if (selected.category) {
          let terms = {}
          terms['appliedTagMap.' + selected.category + '.name'] = [selected.name]
          should.push({
            'terms': terms
          })
        }
        should.push({
          'query_string': {
            'query': '"' + String(selected.name).replace(/"/g, '') + '"',
            'fields': ['appliedTagMap.*.name']
          }
        })
        should.push({
          'terms': {
            'careerCompetenciesList.name': [selected.name]
          }
        })
        should.push({
          'terms': {
            'careerCompetenciesList.name.keyword': [selected.name]
          }
        })
        must.push({
          'bool': {
            'should': should,
            'minimum_should_match': 1
          }
        })
      })
      return {
        'bool': {
          'must': must
        }
      }
    },
    applyIncomingEmployerFilter () {
      let employerName = this.$route.query.employer
      this.ignoreEmployerWatch = true
      if (employerName) {
        this.employerSelected = [employerName]
        this.storeJobSelectedFacets({key: 'employerSelected', value: [employerName]})
      } else {
        this.employerSelected = (this.selectedFacets.employerSelected || []).slice()
      }
    },
    removeSelectedFacet (key, index) {
      if (key === 'jobTypeSelected') {
        this.jobTypeSelected.splice(index, 1)
      } else if (key === 'employerSelected') {
        this.employerSelected.splice(index, 1)
      } else if (key === 'salaryRangeSelected') {
        this.salaryRangeSelected.splice(index, 1)
      } else if (key === 'tagSelected') {
        let removed = this.tagSelectionName(this.tagSelected[index])
        this.tagSelected.splice(index, 1)
        if (this.$route.query.tag && this.$route.query.tag === removed) {
          let query = Object.assign({}, this.$route.query)
          delete query.tag
          this.$router.replace({ query: query })
        }
      } else if (key === 'distanceSelected') {
        this.ignoreDistanceWatch = true
        this.distanceSelected = ''
        this.storeJobSelectedFacets({key: 'distanceSelected', value: []})
      } else if (key === 'recommendedSelected') {
        this.showRecommendedOnly = false
        this.storeJobSelectedFacets({key: 'recommendedSelected', value: []})
      }
      this.updateFacet()
    },
    salaryRangeQuery (group) {
      let must = []
      if (group.minLt !== undefined) {
        must.push({
          'range': {
            'minSalary': { 'lt': group.minLt }
          }
        })
      }
      if (group.minGt !== undefined) {
        must.push({
          'range': {
            'minSalary': { 'gt': group.minGt }
          }
        })
      }
      if (group.maxLt !== undefined) {
        must.push({
          'range': {
            'maxSalary': { 'lt': group.maxLt }
          }
        })
      }
      if (must.length === 1) {
        return must[0]
      }
      return {
        'bool': {
          'must': must
        }
      }
    },
    selectedSalaryRangeQueries () {
      let queries = []
      for (let i = 0; i < this.salaryRangeGroups.length; i++) {
        let group = this.salaryRangeGroups[i]
        if (this.salaryRangeSelected.indexOf(group.label) !== -1) {
          queries.push(this.salaryRangeQuery(group))
        }
      }
      return queries
    },
    isRecommendedJob (job) {
      return !!(job && job.uuid && this.recommendedJobIds.indexOf(job.uuid) !== -1)
    },
    normalizeRecommendedJobIds (res) {
      let list = res
      if (res && res.data && Array.isArray(res.data)) {
        list = res.data
      }
      if (!Array.isArray(list)) {
        list = list ? [list] : []
      }
      let ids = []
      list.forEach(item => {
        let id = ''
        if (typeof item === 'string') {
          id = item
        } else if (item) {
          id = item.uuid || item.jobUuid || item.jobId || item.entityUuid || item.entityId || ''
        }
        if (id && ids.indexOf(id) === -1) {
          ids.push(id)
        }
      })
      return ids
    },
    loadRecommendedJobIds () {
      if (this.recommendedJobIdsLoaded) {
        return Promise.resolve(this.recommendedJobIds)
      }
      return this.loadAllJobIdsWithRecommendation().then(res => {
        this.recommendedJobIds = this.normalizeRecommendedJobIds(res)
        this.recommendedJobIdsLoaded = true
        return this.recommendedJobIds
      }).catch(() => {
        this.recommendedJobIds = []
        this.recommendedJobIdsLoaded = true
        return this.recommendedJobIds
      })
    }
  }
}
</script>

<style scoped>
  .job-result-row {
    padding: 12px 16px;
    border-bottom: 1px solid #e6e6e6;
    background: #fff;
  }
  .job-title-row {
    display: flex;
    align-items: flex-start;
    margin-bottom: 8px;
  }
  .job-title {
    flex: 1;
    font-weight: 500;
    color: #4a4a4a;
  }
  .recommendation-star {
    margin-left: 4px;
    margin-top: 2px;
    color: #e08a4a;
    flex-shrink: 0;
  }
  .job-salary-item {
    min-width: 0;
    overflow: hidden;
    max-width: 100%;
  }
  .job-salary-item .salary-text {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .job-type-item {
    flex: 0 0 auto;
    min-width: max-content;
  }
  .ic_bm_container {
    margin-left: 8px;
  }
  .ic_bm_container.bookmarked {
    color: #3d5a99;
  }
  .job-employer {
    display: flex;
    align-items: center;
    margin-bottom: 8px;
  }
  .employer-avatar {
    width: 72px;
    height: 28px;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 10px;
    color: #000;
    font-weight: 600;
    overflow: hidden;
    flex-shrink: 0;
  }
  .employer-avatar.has-logo {
    background: transparent;
  }
  .employer-avatar img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
  .job-meta-row {
    display: flex;
    justify-content: space-between;
    color: #6b6b6b;
    font-size: 13px;
    margin-top: 6px;
    gap: 12px;
  }
  .job-meta-item {
    display: flex;
    align-items: center;
    min-width: 0;
    flex: 1;
  }
  .job-meta-item .meta-icon {
    margin-right: 6px;
    flex-shrink: 0;
    font-size: 16px;
    color: #4a4a4a;
  }
  .job-pagination {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 16px;
    gap: 16px;
  }
  .job-pagination .btn {
    color: #fff;
  }
  .job-pagination .btn:disabled {
    color: #fff;
    opacity: 1;
  }
  .current-page {
    min-width: 24px;
    text-align: center;
  }
  .filter_option.is-active,
  .filter_option label.is-active {
    font-weight: 600;
  }
  .distance-state-select {
    margin-bottom: 12px;
  }
  .job_board .selected_filters_container {
    float: none;
    overflow: visible;
  }
  .job-filter-chips {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    gap: 8px;
    width: 100%;
    padding: 4px 16px 8px 0;
    box-sizing: border-box;
  }
  .job-filter-chip {
    display: inline-flex;
    flex-direction: row;
    align-items: stretch;
    flex: 0 1 auto;
    max-width: 100%;
    border: 1px solid #b3b3b3;
    background: #fff;
    overflow: hidden;
  }
  .job-filter-chip-label {
    display: block;
    padding: 6px 8px;
    line-height: 1.3;
    word-break: break-word;
  }
  .job-filter-chip-label.job-type-tag {
    background-color: #ffb0c4;
  }
  .job-filter-chip-label.employer-tag {
    background-color: #7ad8f0;
  }
  .job-filter-chip-label.salary-tag {
    background-color: #c8e6c0;
  }
  .job-filter-chip-label.distance-tag {
    background-color: #d4c5f0;
  }
  .job-filter-chip-label.job-applied-tag {
    background-color: #f6e59b;
  }
  .job-filter-chip-label.recommended-tag {
    background-color: #fff8dc;
  }
  .job-filter-chip-remove {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 32px;
    width: 32px;
    margin: 0;
    padding: 0;
    border: 0;
    border-left: 1px solid #dcdcdc;
    background: #fff;
    color: #4a6d8c;
    cursor: pointer;
  }
  .job-filter-chip-remove .ic_bin {
    font-size: 16px;
    line-height: 1;
  }
</style>



// WEBPACK FOOTER //
// src/app/job/components/JobBoard.vue